import { Dialog } from "primereact/dialog";
import CustomeButton from "../../Button/index";

export default function ConfimModal({ visible, closeModal, deleteSevice }) {
  return (
    <div className="modal-main-container card flex justify-content-center">
      <Dialog
        visible={visible}
        onHide={closeModal}
        className="user-delete-confirmation"
      >
        <p className="delete-dialog-heading mt-5">
          {`Are you sure you want to disable this service?`}
        </p>
        <p className="delete-dialog-desc">
          Disabling will remove it from the user interface and its data will
          still be available upon request.
        </p>
        <div className="flex justify-content-end mt-5">
          <CustomeButton
            label="Cancel"
            variant="outlined"
            className="mr-2"
            onClick={closeModal}
          />
          <CustomeButton
            label={"Yes, disable"}
            variant="remove"
            onClick={deleteSevice}
          />
        </div>
      </Dialog>
    </div>
  );
}
